import analytics from "@/lib/analytics";

export default function useAnalytics() {
  return {
    page: analytics.page,
    track: analytics.track,
    identify: analytics.identify,
  };
}
